export default __webpack_public_path__ + "static/media/midlane.65441858.png";